import { useUpdateAddressDirectScheduleAdjustmentMutation } from '@/hooks/apis';
import { queryClient, queryKeys } from '@/infrastructure';
import { FlashContext } from '@/providers';
import { Order } from '@/types';
import { bem } from '@/utilities';
import React, { useContext, useState } from 'react';

type Props = {
  order: Order;
  token: string;
  onConfirmAddress: () => void;
};

export const AddressForm: React.FC<Props> = (props) => {
  const { order, token, onConfirmAddress } = props;
  const [address, setAddress] = useState<string>(order?.location);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const { mutate, isLoading } = useUpdateAddressDirectScheduleAdjustmentMutation(token);
  const [hasAddressError, setHasAddressError] = useState<boolean>(false);
  const { setFlash } = useContext(FlashContext);

  const updateAddress = () => {
    setHasAddressError(false);

    mutate(
      { orderId: order.id, address },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([queryKeys.directScheduleAdjustmentTimeframe, token]);
          setFlash({
            type: 'success',
            message: <>住所を変更しました。</>
          });
          setIsEditing(false);
          onConfirmAddress();
        },
        onError: () => {
          setHasAddressError(true);
        }
      }
    );
  };

  return (
    <div className={bem('schedule-selection', 'address')}>
      <h1 className={bem('schedule-selection', 'address-title')}>1 作業場所住所を確認</h1>
      <div className={bem('schedule-selection', 'address-descriptions')}>
        <p className={bem('schedule-selection', 'address-description')}>
          以下の住所が作業場所住所として登録されています。
        </p>
        <p className={bem('schedule-selection', 'address-description')}>
          作業場所の住所が異なる場合は「住所を変更する」ボタンをクリックして編集し、「保存する」ボタンをクリックしてください。保存すると自動的に次のステップに進みます。
        </p>
        <p className={bem('schedule-selection', 'address-description')}>
          住所が正しい場合は「住所を確定する」ボタンをクリックしてください。
        </p>
      </div>
      <h2 className={bem('schedule-selection', 'address-subtitle')}>作業場所住所</h2>
      {isEditing ? (
        <input
          className={bem('schedule-selection', 'address-input')}
          onChange={(e) => setAddress(e.target.value)}
          value={address}
          placeholder='東京都港区六本木３丁目１−１７ 第２ABビル 6F'
        />
      ) : (
        <p className={bem('schedule-selection', 'address-text')}>{address}</p>
      )}
      <div className={bem('schedule-selection', 'address-form')}>
        {isEditing ? (
          <button
            type='button'
            className={bem('schedule-selection', 'address-button')}
            disabled={isLoading}
            onClick={() => updateAddress()}
          >
            保存する
          </button>
        ) : (
          <button
            type='button'
            className={bem('schedule-selection', 'address-button')}
            onClick={() => setIsEditing(true)}
          >
            住所を変更する
          </button>
        )}

        <button
          type='button'
          className={bem('schedule-selection', 'address-confirm-button')}
          disabled={isEditing || isLoading}
          onClick={() => onConfirmAddress()}
        >
          住所を確定する
        </button>
      </div>
      {hasAddressError && (
        <p className={bem('schedule-selection', 'address-error')}>
          入力された住所の形式が正しくありません。住所は都道府県から入力してください。
        </p>
      )}
    </div>
  );
};
